import { ENVS } from 'types/envs';

export const isEnvProduction = () => {
  const ENV = process.env.REACT_APP_ENVIRONMENT;
  return ENV === ENVS.PROD;
};
